import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  LineChart, StackedBarChart,
} from '@iris-platform/iris-react-ui';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import DataProcessor from './dataprocessor';

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '75%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    textAlign: 'right',
    alignItems: 'right',
  },
  panel: {
    width: '100%',
  },
  spacer20: {
    height: '20 px',
  },
  centered: {
    margin: 'auto',
    textAlign: 'center',
    alignItems: 'center',
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  details: {
    alignItems: 'center',
  },
  column: {
    flexBasis: '75%',
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  chart: {
    height: '400px',
    width: '600px',
  },
});

const GET_SERVICE_DATA = gql`
    query apiResponseTimes ($server: String!, $time: String!){
      apiResponseTimes(server:$server, time:$time){
        servertype
        apimethod
        time_bucket
        status_counts{
          status_code
          status_count
        }
        percentiles{
            percentile
            value
          }
        totalrequest
        objectId
        createdAt
        updatedAt
      }
    }
  `;

class ApiResponseData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.eachApi = this.eachApi.bind(this);
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  }

  eachApi(api, i) {
    const { props } = this;
    const { classes } = props;
    const { expanded } = this.state;
    return (
      <ExpansionPanel key={api.apiMethod} className={classes.panel} expanded={expanded === `panel${i}`} onChange={this.handleChange(`panel${i}`)}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <div className={classes.column}>
            <Typography className={classes.heading}>{api.apiMethod}</Typography>
          </div>
          <div className={classes.column}>
            <Typography className={classes.secondaryHeading}>
              {api.totalrequest}
              {' '}
              Requests
            </Typography>
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div>
            <div className={classes.chart}>
              <StackedBarChart data={api.barChartData} />
            </div>
            <br />
            <div className={classes.chart}>
              <LineChart data={api.lineChartData} />
            </div>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }

  render() {
    const { props } = this;
    const { classes } = props;
    const QUERY_VARIABLES = {
      server: props.server,
      time: props.time,
    };
    return (
      <Query
        query={GET_SERVICE_DATA}
        notifyOnNetworkStatusChange
        variables={QUERY_VARIABLES}
      >

        {({ data, loading, error }) => {
          if (loading) return null;
          if (error) return `Error!: ${error}`;
          const callData = data && data.apiResponseTimes && !loading
            ? DataProcessor(data) : [];
          if (callData === []) {
            return (
              <div className={classes.panelHeader}>Query returned no data</div>
            );
          }
          return (
            <div>
              <div>
                <div className={classes.spacer20}>&nbsp;</div>
                <div className={classes.centered}>{callData.serviceDisplay}</div>
                <div className={classes.spacer20}>&nbsp;</div>
                <div className={classes.root}>
                  {callData.data.map(this.eachApi)}
                </div>
              </div>
            </div>
          );
        }}

      </Query>
    );
  }
}

export default withStyles(styles)(ApiResponseData);
